__turbopack_context__.v({
  "icecat-product-story": "icecat-product-story-component-module-scss-module__98CtHa__icecat-product-story",
});
